import React from "react";
import ComingSoon from "@/Utility/ComingSoon/ComingSoon";

const IssueTypesSettings = () => {
  return (
    <div className="bg-surface-primary border border-border-primary rounded-md shadow-sm p-6">
      <ComingSoon title="Issue types settings" />
    </div>
  );
};

export default IssueTypesSettings;
